<template>
  <div class="text-xs flex flex-row w-full justify-between item">
    <div>+ {{ addOnDescription }}</div>
    <div class="text-gray-500 text-xs whitespace-nowrap">
      <div
        :class="[
          narrow ? 'flex-col items-end' : 'flex-row items-center space-x-2',
          'flex',
        ]"
      >
        <DomainAddOnPriceDisplay :add-on-id="addOnId" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useDomainAddOnCatalogStore } from "../../stores/catalog/domain-addon-catalog";

const props = withDefaults(
  defineProps<{
    narrow?: boolean;
    cartItemId: string;
    addOnId: number;
  }>(),
  {
    narrow: false,
  }
);

const domainAddOnCatalog = useDomainAddOnCatalogStore();

const addOnDescription = computed(() => {
  const addon = domainAddOnCatalog.getSubscriptionByAddOnId(props.addOnId);

  return addon?.name ?? "<ukjent addon>";
});
</script>

<style></style>
